import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LandingHeader from '../Shared/LandingHeader';
import LandingFooter from '../Shared/LandingFooter';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
    const { t } = useTranslation(['privacy', 'common']);
    const sections = t('privacy:sections', { returnObjects: true }) || [];

    return (
        <div className="pp-page">
            <LandingHeader activePage="privacy" />

            <main style={{ paddingTop: '80px' }}>
                {/* Hero */}
                <section className="pp-hero">
                    <div className="pp-container">
                        <div className="pp-hero-badge">{t('privacy:hero.badge')}</div>
                        <h1>{t('privacy:hero.title')} <span className="pp-gradient">{t('privacy:hero.titleHighlight')}</span></h1>
                        <p className="pp-hero-sub">{t('privacy:hero.subtext')}</p>
                        <div className="pp-meta">
                            <span>📅 {t('privacy:hero.lastUpdatedLabel', 'Last Updated')}: {t('privacy:hero.lastUpdated')}</span>
                            <span>⏱ {t('privacy:hero.readTime')}</span>
                        </div>
                    </div>
                    <div className="pp-hero-glow" />
                </section>

                {/* Quick Nav */}
                <section className="pp-toc-section">
                    <div className="pp-container">
                        <div className="pp-toc">
                            <h3>{t('privacy:tocTitle')}</h3>
                            <ul>
                                {sections.map((s) => (
                                    <li key={s.id}>
                                        <a href={`#section-${s.id}`}>
                                            <span className="pp-toc-num">{s.id}</span>
                                            {s.title}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </section>

                {/* Content */}
                <section className="pp-content-section">
                    <div className="pp-container pp-layout">
                        <div className="pp-sections">
                            {sections.map((sec) => (
                                <div className="pp-section" id={`section-${sec.id}`} key={sec.id}>
                                    <div className="pp-section-header">
                                        <span className="pp-section-num">{sec.id}</span>
                                        <h2>{sec.title}</h2>
                                    </div>
                                    <div className="pp-sub-items">
                                        {sec.content.map((item, i) => (
                                            <div className="pp-sub-item" key={i}>
                                                <h4>{item.subtitle}</h4>
                                                <p>{item.text}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Sticky sidebar */}
                        <aside className="pp-sidebar">
                            <div className="pp-sidebar-card">
                                <div className="pp-sidebar-icon">🔒</div>
                                <h3>{t('privacy:sidebar.safeTitle')}</h3>
                                <p>{t('privacy:sidebar.safeText')}</p>
                            </div>
                            <div className="pp-sidebar-card">
                                <div className="pp-sidebar-icon">📬</div>
                                <h3>{t('privacy:sidebar.contactTitle')}</h3>
                                <p>{t('privacy:sidebar.contactText')}</p>
                                <a href="mailto:support@skilltherapyai.com" className="pp-contact-link">
                                    support@skilltherapyai.com
                                </a>
                            </div>
                            <div className="pp-sidebar-card pp-sidebar-card--highlight">
                                <h3>{t('privacy:sidebar.relatedTitle')}</h3>
                                <ul className="pp-related-links">
                                    <li><Link to="/about">{t('common:about', 'About Us')}</Link></li>
                                    <li><Link to="/terms">{t('common:terms', 'Terms of Service')}</Link></li>
                                </ul>
                            </div>
                        </aside>
                    </div>
                </section>

                {/* CTA */}
                <section className="pp-cta-section">
                    <div className="pp-container">
                        <h2>{t('privacy:cta.title')}</h2>
                        <p>{t('privacy:cta.text')}</p>
                        <a href="mailto:support@skilltherapyai.com" className="pp-btn-primary">
                            {t('privacy:cta.button')}
                        </a>
                    </div>
                </section>
            </main>

            <LandingFooter />
        </div>
    );
};

export default PrivacyPolicy;
